import { render, staticRenderFns } from "./DragAndDropMemo.vue?vue&type=template&id=b3ebbbac&scoped=true&"
import script from "./DragAndDropMemo.vue?vue&type=script&lang=js&"
export * from "./DragAndDropMemo.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDropMemo.vue?vue&type=style&index=0&id=b3ebbbac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ebbbac",
  null
  
)

/* custom blocks */
import block0 from "./DragAndDropMemo.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports